<template>
  <div>
    <div class="page-title">
      {{ $t('developer.application_setting') }}
    </div>
    <div class="merchant-application-detail page-container">

      <div class="setting-item">
      <p class="setting-title">
        {{ $t('developer.shared_application_setting') }}
        <el-tooltip placement="top">
          <div slot="content" style="width: 300px">
            <span>{{ $t('tips.shared_application_setting_tips') }}</span>
          </div>
          <svg-icon class-name="icon-question" icon-class="help-question" />
        </el-tooltip>
        <el-switch
          v-model="sharePublicKeyStatus"
          :active-value="1"
          :inactive-value="2"
          :active-text="sharePublicKeyStatus===1?'Open':'Close'"
          active-color="#67C23A"
          inactive-color="#F56C6C"
          :disabled="!publicKeyFlag"
          @change="changeSharePublicKeyStatus"
          style="margin-left: 10px;"
        />
      </p>
      </div>

      <div class="setting-item">
        <p class="setting-title">
          {{ $t('developer.application_information') }}
        </p>
        <div style="margin-top: 16px">
          <span class="setting-key">AppId:</span>
          <span class="setting-value">{{ application.app_id }}</span>
        </div>
      </div>

      <div class="setting-item">
        <p class="setting-title">Webhook</p>
        <div class="setting-item-content">
          <div class="setting-item-content-left">
            <span class="setting-key">Pay out: </span>
            <span v-if="!noticeWebhookFlag" class="setting-value">{{ application.notice_webhook ? application.notice_webhook : '' }}</span>&nbsp;
            <template v-else>
              <el-input v-model="webhookForm.notice_webhook" class="search-frame" :placeholder="$t('merchant.notice_webhook')" />

            </template>
          </div>
          <div class="setting-item-content-right">
            <el-button v-if="!noticeWebhookFlag" type="primary" plain @click="changeWebhookInput(1)">
              {{ $t('components.edit') }}
            </el-button>
            <el-button v-else type="primary" @click="submitMchWebhook(1)">{{ $t('components.submit') }}</el-button>
          </div>
        </div>
      </div>

      <div class="setting-item">
        <p class="setting-title">
          API Key
          <el-tooltip placement="top">
            <div slot="content">
              <span> {{ $t('tips.public_key_introduce') }}</span> <br>
            </div>
            <span>  <svg-icon class-name="icon-question" icon-class="help-question" /></span>
          </el-tooltip>
        </p>


        <div class="setting-item-content">
          <div class="setting-item-content-left">
            <span class="setting-key"> {{ $t('developer.public_key') }}: </span>
            <span v-if="!publicKeyInputFlag" class="setting-value" style="position: relative; top: 3px">{{ hiddenInfo.public_key }}</span>
          </div>
          <div class="setting-item-content-right">
            <el-button v-if="publicKeyFlag && !publicKeyInputFlag" type="primary" plain @click="changeHiddenInput(1)">  {{ $t('components.edit') }}</el-button>
            <el-button v-if="publicKeyInputFlag" type="primary" @click="submitReSetPublicSecret(1)">{{ $t('components.submit') }}</el-button>
            <template>
              <el-button v-if="!publicKeyFlag" type="primary" plain @click="showUserAuthenticationModal('public_key_second')">
                {{ $t('components.view') }}
              </el-button>
            </template>

          </div>
        </div>

        <el-input
          v-if="publicKeyInputFlag"
          v-model="hiddenForm.public_key"
          style="margin-top: 12px"
          type="textarea"
          :rows="8"
          clearable
        />
      </div>

      <div class="setting-item">

        <p class="setting-title">{{ $t('developer.ip_white_list') }}
          <el-tooltip placement="top">
            <div slot="content">
              <span> {{ $store.getters.isAruxpay ? $t('tips.ip_white_aruxpay_introduce') : $t('tips.ip_white_ezpay_introduce') }}</span> <br>
            </div>
            <span>  <svg-icon class-name="icon-question" icon-class="help-question"/></span>
          </el-tooltip>
        </p>

        <div class="setting-item-content">
          <div class="setting-item-content-left">
            <span class="setting-key">{{ $t('developer.ip_address') }}: </span>
            <span v-if="!ipKeyInputFlag" class="setting-value" style="position: relative; top: 3px">{{ hiddenInfo.white_ips }}</span>
            <template />
          </div>
          <div class="setting-item-content-right">
            <!--            <el-button v-if="ipKeyFlag && !ipKeyInputFlag" type="primary" plain @click="changeHiddenInput(2)">  {{ $t('components.edit') }}</el-button>-->
            <!--            <el-button v-if="ipKeyInputFlag" type="primary" @click="submitReSetWhiteIps">{{ $t('components.submit') }}</el-button>-->
            <template>
              <el-button v-if="!ipKeyFlag" type="primary" plain @click="showUserAuthenticationModal('white_ips_second')">
                {{ $t('components.view') }}
              </el-button>

            </template>

          </div>
        </div>

        <!--        <el-input-->
        <!--          v-if="ipKeyInputFlag"-->
        <!--          v-model="hiddenForm.white_ips"-->
        <!--          style="margin-top: 12px"-->
        <!--          clearable-->
        <!--        />-->

      </div>

      <el-dialog
        :title="$t('developer.shared_application_setting')"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="closeSharePublicKeyDialog"
      >
        <p style="margin-bottom: 50px">{{ $t('tips.share_public_key_introduce') }}</p>

<!--        <p style="margin-bottom: 20px">Pay out</p>-->
<!--        <el-input v-model="hiddenInfo.notice_webhook" type="textarea" :rows="1" style="margin-bottom: 20px"/>-->

<!--        <p style="margin-bottom: 20px">{{ $t('developer.ip_address') }}</p>-->
<!--        <el-input v-model="hiddenInfo.white_ips" type="textarea" :rows="2" style="margin-bottom: 20px"/>-->

<!--        <el-form ref="form" :model="form">-->
<!--          <p style="margin-bottom: 20px">{{ $t('developer.public_key') }}</p>-->
<!--          <el-form-item>-->
<!--            <el-input v-model="hiddenInfo.public_key" type="textarea" :rows="10" />-->
<!--          </el-form-item>-->
<!--        </el-form>-->

        <div slot="footer" class="dialog-footer">
          <el-button @click="closeSharePublicKeyDialog">{{ $t('components.cancel') }}</el-button>
          <el-button type="primary" @click="submitSharePublicKey()">{{ $t('components.confirm') }}</el-button>
        </div>
      </el-dialog>

      <AppIdentityEmailCheckModal ref="identityCheckPublicKeyRef" :app_id_second="checkType" @showHiddenInfo="showHiddenInfo" />
      <AppIdentityEmailCheckModal ref="identityCheckWhiteIpsRef" :app_id_second="checkType" @showHiddenInfo="showHiddenInfo" />
    </div>
  </div>
</template>

<script>

import { fetchMerchantAppList, updateMerchantAppEvent, reSetSecret, reSetPublicSecret, reSetMchAppWhiteIps, updateSharePublicConfig } from '@/api/merchant-manage/merchant-manage'
import {cryptoJSAesEncrypt} from "@/utils/encrypt";

export default {
  name: 'Develop_Manage_App_Detail',
  components: {
    // ApplicationIdentityCheckModal: () => import('./components/Modal/ApplicationIdentityCheckModal')
    AppIdentityEmailCheckModal: () => import('./components/Modal/AppIdentityEmailCheckModal')
  },
  data() {
    return {
      application: {},
      sharePublicKeyStatus: 1,
      dialogVisible: false,
      hiddenInfo: {
        public_key: '********',
        secret_key: '********',
        white_ips: '********'
      },
      checkType: '',
      webhookForm: {
        notice_webhook: '',
        qr_webhook: '',
        transfer_webhook: ''
      },
      sharePublicKeyForm: {
        share_public_key_status: '',
        public_key: ''
      },
      hiddenForm: {
        id: '',
        public_key: '',
        white_ips: ''
      },
      mfaForm: {
        msg_code: ''
      },
      form: {
        name: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      noticeWebhookFlag: false,
      qrWebhookFlag: false,
      bankWebhookFlag: false,
      publicKeyFlag: false,
      secretKeyFlag: false,
      ipKeyFlag: false,
      publicKeyInputFlag: false,
      secretKeyInputFlag: false,
      ipKeyInputFlag: false
    }
  },
  mounted() {
    this.getMerchantAppList()
  },
  methods: {
    getMerchantAppList() {
      fetchMerchantAppList().then(res => {
        const record = res.data
        const that = this
        record.forEach(function(item, index) {
          if (index === 0) {
            that.application = item
            that.sharePublicKeyStatus = item.share_public_key_status || 2
          }
        })
      })
    },
    changeSharePublicKeyStatus(row) {
      if (this.sharePublicKeyStatus === 1) {
        this.dialogVisible = true
        return
      }
      const params = {
        share_public_key_status: 2
      }
      updateSharePublicConfig(params).then(res => {
        if (res.code === 10000) {
          this.$message.success('Success')
        }
      })
    },
    closeSharePublicKeyDialog() {
      this.hiddenInfo.public_key = this.sharePublicKeyForm.public_key
      this.sharePublicKeyStatus = 2
      this.dialogVisible = false
    },
    submitSharePublicKey(row) {
      // this.hiddenInfo.public_key = this.hiddenInfo.public_key.trim()
      // if (!this.hiddenInfo.public_key || !this.hiddenInfo.notice_webhook || !this.hiddenInfo.white_ips) {
      //   return this.$message.warning(this.$t('tips.share_public_key_empty'))
      // }
      // this.$confirm(this.$t('tips.share_public_key_to_verify'), 'Tips', {
      //   confirmButtonText: this.$t('components.confirm'),
      //   cancelButtonText: this.$t('components.cancel'),
      //   type: 'warning'
      // }).then(() => {
      const params = {
        share_public_key_status: this.sharePublicKeyStatus,
        public_key: cryptoJSAesEncrypt(this.hiddenInfo.public_key),
        notice_webhook: this.application.notice_webhook,
        // white_ips: this.hiddenInfo.white_ips
      }
      updateSharePublicConfig(params).then(res => {
        if (res.code === 10000) {
          this.sharePublicKeyForm.public_key = this.hiddenInfo.public_key
          this.$message.success('Success')
          this.dialogVisible = false
          this.getMerchantAppList()
        }
      })
      // })
    },
    changeWebhookInput(index) {
      this.webhookForm.app_id = this.application.app_id
      this.webhookForm.notice_webhook = this.webhookForm.notice_webhook ? this.webhookForm.notice_webhook : this.application.notice_webhook
      this.webhookForm.qr_webhook = this.webhookForm.qr_webhook ? this.webhookForm.qr_webhook : this.application.qr_webhook
      this.webhookForm.transfer_webhook = this.webhookForm.transfer_webhook ? this.webhookForm.transfer_webhook : this.application.transfer_webhook

      if (index === 1) {
        this.noticeWebhookFlag = true
      }
      if (index === 2) {
        this.qrWebhookFlag = true
      }
      if (index === 3) {
        this.bankWebhookFlag = true
      }
    },
    changeHiddenInput(index) {
      this.hiddenForm.id = this.application.app_id
      if (index === 1) {
        this.publicKeyInputFlag = true
        this.hiddenForm.public_key = this.hiddenInfo.public_key
      }
      if (index === 2) {
        this.ipKeyInputFlag = true
        this.hiddenForm.white_ips = this.hiddenInfo.white_ips
      }
    },
    submitMchWebhook(index) {
      const {notice_webhook, qr_webhook, transfer_webhook} = this.webhookForm
      if (!notice_webhook && !qr_webhook && !transfer_webhook) {
        this.$message.warning('Merchant callback interfaces cannot be NULL')
        return
      }
      const msg = this.sharePublicKeyStatus === 1 ? this.$t('tips.share_public_key_to_verify') : this.$t('tips.share_public_webhook_to_update')
      this.$confirm(msg, 'Tips', {
        confirmButtonText: this.$t('components.confirm'),
        cancelButtonText: this.$t('components.cancel'),
        type: 'warning'
      }).then(() => {
        updateMerchantAppEvent(this.webhookForm).then(res => {
          this.$message.success('Update Successfully')
          if (index === 1) {
            this.noticeWebhookFlag = false
          }
          if (index === 2) {
            this.qrWebhookFlag = false
          }
          if (index === 3) {
            this.bankWebhookFlag = false
          }
          this.getMerchantAppList()
        })
      })
    },
    // showUserAuthenticationModal() {
    //   if (this.application.app_id) {
    //     this.$refs.identityCheckRef.changModalStatus(true, this.application.app_id)
    //   }
    // },
    showUserAuthenticationModal(type) {
      this.checkType = type
      if (this.application.app_id) {
        if (type === 'public_key_second') {
          this.$refs.identityCheckPublicKeyRef.changModalStatus(true, this.application.app_id)
        }
        if (type === 'white_ips_second') {
          this.$refs.identityCheckWhiteIpsRef.changModalStatus(true, this.application.app_id)
        }
      }
    },
    showHiddenInfo(value) {
      if (value.check_status) {
        // this.hiddenInfo.secret_key = value.secret
        this.hiddenInfo.public_key = value.public_key
        this.hiddenInfo.white_ips = value.white_ips

        this.sharePublicKeyForm.share_public_key_status = this.sharePublicKeyStatus
        this.sharePublicKeyForm.public_key = value.public_key

        this.publicKeyFlag = true
        this.secretKeyFlag = true
        this.ipKeyFlag = true

        // this.publicKeyInputFlag = true
        // this.secretKeyInputFlag = true
        // this.ipKeyInputFlag = true
      }
    },
    submitReSetSecret() {
      this.$confirm('Did you want to re-set Secret Key?', 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        const params = { id: this.application.app_id }
        reSetSecret(params).then(res => {
          this.$message.success('Success')
          // this.hiddenInfo.secret_key = res.data.secret
        })
      })
    },
    submitReSetPublicSecret() {
      const msg = this.sharePublicKeyStatus === 1 ? this.$t('tips.share_public_key_to_verify') : this.$t('tips.share_public_key_to_update')
      this.$confirm(msg, 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        const params = {
          app_id: this.hiddenForm.id,
          public_key: cryptoJSAesEncrypt(this.hiddenForm.public_key)
        }

        reSetPublicSecret(params).then(res => {
          this.$message.success('Success')
          this.hiddenInfo.public_key = this.hiddenForm.public_key
          this.publicKeyInputFlag = false
        })
      })
    },
    submitReSetWhiteIps() {
      if (!this.validateIPAddresses(this.hiddenForm.white_ips)) {
        return;
      }
      const msg = this.sharePublicKeyStatus === 1 ? this.$t('tips.share_public_key_to_verify') : this.$t('tips.share_public_ip_to_update')
      this.$confirm(msg, 'Tips', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        const params = {
          app_id: this.hiddenForm.id,
          white_ips: this.hiddenForm.white_ips
        }

        reSetMchAppWhiteIps(params).then(res => {
          this.$message.success('Success')
          this.hiddenInfo.white_ips = this.hiddenForm.white_ips
          this.ipKeyInputFlag = false
        })
      })
    },
    validateIPAddresses (value) {
      if(/\s/g.test(value)){
        this.$message.warning('The input value cannot contain spaces');
        return false;
      }
      const ipRegex = /^((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}(\/(3[0-2]|[1-2]?\d))?)(,\s*((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}(\/(3[0-2]|[1-2]?\d))?))*$/;
      if (!ipRegex.test(value)) {
        this.$message.warning('Please enter a valid IP address, separated by commas');
        return false;
      }
      return true;
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-item{
  margin-bottom: 48px;
}
.setting-item-content{
  display: flex;
  justify-content: space-between;
}

  .search-frame {
    width: 550px;
    margin: 5px;
  }
  .submit-btn {
    margin: 5px;
  }
  .application-detail-webhook {
    width: 100%;
    min-height: 140px;
    padding: 24px 0;
  }
  .application-detail-apiKey {
    width: 100%;
    min-height: 170px;
    padding: 24px 0;
  }
  .application-detail-ip {
    width: 100%;
    padding: 24px 0;
  }
  p {margin: 0}
  .setting-title {
    margin-bottom: 5px;
    color: #364250;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
  .setting-key {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 1.3;
    color: #5E6E82;
  }
  .setting-value {
    margin-left: 5px;
    max-width: 600px;
    color: #488CE8;
    font-size: 14px;
    font-weight: 400;
    word-break: break-all;
  }
  .setting-item-content-left{
    display: flex;
    align-items: center;

  }
  .setting-title-dec {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #98A1B4;
  }
  .icon-hover{
   cursor: pointer;
  }
  .icon-hover:hover {
    font-size: 22px;
    color: #3855F1;
  }
</style>
